import { HistoryInvSalesChartComponent } from './history-inv-sales-chart.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';

import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { ChartsModule } from 'ng2-charts';

@NgModule({
  imports: [CommonModule, NgxMaskDirective, NgxMaskPipe, ChartsModule, TooltipModule, TableModule],
  declarations: [HistoryInvSalesChartComponent],
  exports: [HistoryInvSalesChartComponent],
})
export class HistoryInvSalesChartModule {}
